
import React from "react"
import { Row, Col } from 'antd'
import classes from './404.module.css'
import { useTranslation } from "react-i18next"
import {  Link } from 'react-router-dom'
import HelmetComponent from '../../components/Helmet'

const PageNotFound: React.FC = () => {

  const { t } = useTranslation()

  return (
    <>
      <HelmetComponent title="Error page 404" description="Error page 404" />

      <Row>
        <Col xs={24} sm={24} md={24} lg={24} >
          <div className={classes.container404}>
            <div className={classes.textWrapper}>
              <h1>Error 404</h1>
              <br />
              <h3>{t("Unfortunately, we couldn't find this page!") }</h3>
              <br />
              <p className={classes.link}><Link to="/">{ t('Back to Home Page')}</Link></p>
          </div>
          </div>
        </Col>
      </Row>

    </>
  )
}

export default PageNotFound



